import React, { useEffect, useState } from "react";

import axios from "axios";
import { updateConciergeServiceUrl } from "../../../utils/urls";
import { apiFail, apiStart, apiSuccess } from "../../../store/actions/apiActions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import EnableDisableConciergeServiceModal from "../../../components/uiElements/modal/EnableDisableConciergeServiceModal";
import { getActivePatientSubscriptionCountAction, getConciergeServiceAction } from "../../../store/actions/dashboardActions";

const ConciergeServiceSettings = () => {
	const [isOpen, setIsOpen] = useState(false);

	const activePatientCount = useSelector(state => state.dashboard.conciergeService.countData.activePatientSubscriptionCount);
	const isEnableConciergeService = useSelector(state => state.dashboard.conciergeService.isEnableConciergeService);

	const dispatch = useDispatch();

	const handleConciergeService = () => {
		dispatch(apiStart());
		axios.patch(updateConciergeServiceUrl(), {
			"concierge_service": !isEnableConciergeService
		}).then((res) => {
			if (res?.data?.status_code !== 400) {
				console.log(res.data)
				toast.success(res?.data?.message[0], {
					position: toast.POSITION.BOTTOM_RIGHT
				  });
			} else {
				toast.error	(res?.data?.message[0], {
					position: toast.POSITION.BOTTOM_RIGHT
				  });
			}
			dispatch(apiSuccess())
		}).catch(err => {
			toast.error(err?.data?.message[0], {
                position: toast.POSITION.BOTTOM_RIGHT
              });
			  console.log("IN CONCIERGE",err)
			dispatch(apiFail());
		}).finally((res) => {
			dispatch(getConciergeServiceAction());
		})
	};

	useEffect(() => {
		dispatch(getActivePatientSubscriptionCountAction());
		dispatch(getConciergeServiceAction())
	}, [])

	return (
		<div>
			<p className="DBSubTitle mb-4">Concierge Service</p>
			<div>
			<div>
				<strong className="mb-1 fw-600">
					Offer Unlimited Access
				</strong>
			<br/>
			<p>
				Activate the Concierge Service to provide your patients with unlimited chat, video calls, and voice calls for just $80/month per patient.
			</p>
			</div>
			<div>
			<strong className="mb-1 fw-600">
				How Payments Work
			</strong>
				<p className="mb-1">
					Patients pay $80/month for the Concierge Service.
				</p>
				<p className="mb-1">
					As a doctor, you receive 80% of the fee.
				</p>
				<p>
					UrgiDoctor retains 20% as a technology service fee.
				</p>
			</div>
			<div>
			<strong className="mb-1 fw-600">
				Why Opt In?
			</strong>
				<p className="mb-1">
					Build stronger patient relationships.
				</p>
				<p className="mb-1">
					Offer unmatched convenience and accessibility.
				</p>
				<p className="mb-1">
					Add a reliable revenue stream.
				</p>
				<p className="mb-1">
					Get Started Now!
				</p>
				<p>
					Activate the Concierge Service and elevate your practice today.
				</p>
			</div>
			</div>
			<div className="custom-switch custom-switch-md left">
				<input
					type="checkbox"
					className="custom-control-input"
					id="customSwitches"
					onChange={e => {
						// handleConciergeService();
						setIsOpen(!isOpen)
					}}
					checked={isEnableConciergeService}
				/>
				<label
					className="custom-control-label"
					htmlFor="customSwitches"
					style={{
						fontSize: 16,
					}}
				>
					<span>Activate concierge service</span>
				</label>
			</div>
			<EnableDisableConciergeServiceModal 
			isOpen={isOpen}
			closeModal={() => {setIsOpen(!isOpen)}}
			conciergeService={isEnableConciergeService}
			activePatientCount={activePatientCount}
			onSuccess={()=> {handleConciergeService()}}
			/>
		</div>
	);
};

export default ConciergeServiceSettings;
